/* eslint-disable function-paren-newline */
import { searchValue } from 'src/shared/AppUtils';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { BOOK_KIND, getCurriculumns } from '../SchoolGradeOlogyApis';
import SelectMenu from './SelectMenu';

const DESKTOP_MIN_WIDTH = 640;

function CurriculumsMenu({
  id,
  onSelectCurriculum,
  width,
  bookKind = BOOK_KIND.book,
}) {
  const [curriculums, setCurriculums] = useState([]);
  const [selectedCurriculumKeys, setSelectedCurriculumKeys] = useState([]);
  const [selectedCurriculumKey, setSelectedCurriculumKey] = useState();

  const isDesktop = useMemo(() => width >= DESKTOP_MIN_WIDTH, [width]);

  useEffect(() => {
    if (!id || !width) {
      return;
    }
    getCurriculumns({ id, bookKind }).then((value) => {
      setCurriculums(value);
      if (value.length) {
        const currentId = value[0].CurriculumID;
        if (isDesktop) {
          setSelectedCurriculumKeys([currentId]);
        } else {
          setSelectedCurriculumKey(currentId);
        }
        if (onSelectCurriculum) onSelectCurriculum(value[0]);
      }
    });
  }, [isDesktop, width]);

  const items = useMemo(
    () =>
      curriculums.map(({ CurriculumName, CurriculumID }) => ({
        label: CurriculumName,
        key: CurriculumID,
      })),
    [curriculums]
  );

  const handleSelectItem = useCallback(
    (item) => {
      const key = item.key ?? item;
      if (isDesktop) {
        setSelectedCurriculumKeys([key]);
      } else {
        setSelectedCurriculumKey(key);
      }

      if (onSelectCurriculum) {
        const selectedCurriculum = curriculums.find(
          ({ CurriculumID }) => CurriculumID === key
        );
        onSelectCurriculum(selectedCurriculum);
      }
    },
    [isDesktop, curriculums]
  );

  const handleSearch = useCallback((searchText, option) =>
    searchValue(searchText.toLowerCase(), option.children)
  );

  return (
    <SelectMenu
      isDesktop={isDesktop}
      selectedKeys={selectedCurriculumKeys}
      selectedKey={selectedCurriculumKey}
      menuItems={items}
      handleSelectItem={handleSelectItem}
      handleSearch={handleSearch}
    />
  );
}

export default CurriculumsMenu;
